function baseShoptetEvents() {
  document.addEventListener("ShoptetDOMPageContentLoaded", function () {
    if (
      $(".type-category").length ||
      $(".type-search").length ||
      $(".type-manufacturer-detail").length
    ) {
      if ($("#filters").length) {
        repositionFiltersContent();
      }
    }
  });

  shoptet.scripts.setCustomCallback("shoptet.runtime.resizeEnd", function (
    args
  ) {
    if (
      $(".type-category").length ||
      $(".type-search").length ||
      $(".type-manufacturer-detail").length
    ) {
      setTimeout(() => {
        if ($("#filters").length) {
          repositionFiltersContent();
        }
      }, 1000);
    }
  });
}
